/**
 * 
 * @param {*} url 
 */
export function cdnAssets (url = '') {
  return `https://assets.mgzf.com/h5-static/${url}`
}

export default {
  install (Vue) {
    Vue.prototype.$cdnAssets = cdnAssets
  },
  cdnAssets
}


// WEBPACK FOOTER //
// ./src/plugins/cdnAssets.js